<pia3-general-selector [arrayOfData]="dataObjectArray"></pia3-general-selector>